import React, { Component } from "react";
import { Localize } from "../../modules/localize/Localize";
import { LoadingCircleSVG } from "../Svgs";

/**
 * 按钮
 * 
 * props: {
 * 
 *      {String} name: 显示名称
 *      {function} onClicked: 点击回调
 *      {boolean} primary: 是否是主按钮
 *      {boolean} disabled: 是否可用
 * }
 */
export default class Button extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { name, onClicked, type, disabled, className, widthStyle, rounded, padding, loading = false } = this.props;
        if (type == null || type == "") {
            type = "normal"
        }
        type = type.toLowerCase();

        if (padding == null) {
            padding = "pt-1.5 pb-1.5"
        }
        if (widthStyle == null) {
            widthStyle = " w-32 ";
        }

        if (rounded == null) {
            rounded = " rounded-md ";
        }

        if (disabled == null || disabled != true) {
            disabled = false;
        } else {
            disabled = true;
        }

        const click = e => {
            if (onClicked != null && !disabled) {
                onClicked(e);
            }
        }

        let bg = " bg-gray-400 ";
        let fc = " text-white "

        if (type == "primary") {
            bg = " bg-primary "
            fc = " text-black "
        } else if (type == "buy") {
            bg = " bg-price-up "
            fc = " text-white "
        } else if (type == "sell") {
            bg = " bg-price-down "
            fc = " text-white "
        }

        bg = disabled ? " bg-gray-300 " : bg;
        fc = disabled ? " text-gray-400 " : fc;

        if(name.startsWith("L:")){
            name = name.slice(2);
            name = Localize.getMsgByPath(name);
        }

        const showName = loading ? LoadingCircleSVG : name;

        return (
            <div className={"flex justify-center items-center " + padding + " " + rounded + " " + widthStyle +
                bg + fc + " " + className
            } onClick={click} > {showName}</div>
        );
    }
}